import { createContext } from 'react'

interface FormValueContextProps {
  formValues?: Record<string, any>
}

export const FormValueContext = createContext<FormValueContextProps>({})
